module.exports = __webpack_public_path__ + "static/media/classroom_bottom_animation_2.8813e6ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/classroom/classroom_bottom_animation_2.png
// module id = 1879
// module chunks = 6